import apiClient from './client';

export const adminAuthAPI = {
  // Admin specific login
  adminLogin: (email, password) => apiClient.post('/auth/admin/login', { email, password }),
  
  // Admin specific signup (first super admin creation)
  adminSignup: (data) => apiClient.post('/auth/admin/signup', data),
  
  // Verify admin token
  verifyAdmin: () => apiClient.get('/auth/admin/verify'),
  
  // Admin logout
  adminLogout: () => apiClient.post('/auth/admin/logout'),
  
  // Get admin stats - FIXED: added /auth/
  getAdminStats: () => apiClient.get('/auth/admin/stats'),
  
  // Get all users (admin only) - FIXED: added /auth/
  getAllUsers: (params) => apiClient.get('/auth/admin/users', { params }),
  
  // Get user details (admin only)
  getUserDetails: (userId) => apiClient.get(`/auth/admin/users/${userId}`),
  
  // Approve/reject businesses - FIXED: added /auth/
  approveBusiness: (userId) => apiClient.post(`/auth/admin/approve-business/${userId}`),
  rejectBusiness: (userId, reason) => apiClient.post(`/auth/admin/reject-business/${userId}`, { reason }),
  blockUser: (userId) => apiClient.post(`/auth/admin/block-user/${userId}`),
  deleteUser: (userId) => apiClient.delete(`/auth/admin/users/${userId}`),
  
  // Get pending businesses - FIXED: added /auth/
  getPendingBusinesses: () => apiClient.get('/auth/admin/pending-businesses'),

  getPendingBusinessChangeRequests: () => apiClient.get('/businesses/admin/pending-change-requests'),
  approveBusinessChangeRequest: (requestId) => apiClient.post(`/businesses/admin/approve-change-request/${requestId}`),
  rejectBusinessChangeRequest: (requestId, reason) =>
    apiClient.post(`/businesses/admin/reject-change-request/${requestId}`, { reason }),
  
  // Set subscription (admin only)
  setSubscription: (businessId, planId, status, trialDays) => 
    apiClient.post('/subscriptions/admin/set-subscription', { 
      business_id: businessId, 
      plan_id: planId, 
      status: status, 
      trial_days: trialDays 
    }),
};
